<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item label="用户ID">
          <a-input-number
            v-model="query.userId"
            :min="1"
            placeholder="请输入用户ID"
            style="width: 140px"
          />
        </a-form-item>
        <a-form-item label="积分类型">
          <a-select
            v-model="query.changeType"
            placeholder="全部"
            allow-clear
            style="width: 170px"
          >
            <a-select-option :value="1">充值赠送</a-select-option>
            <a-select-option :value="2">拉新奖励</a-select-option>
            <a-select-option :value="3">报价扣分</a-select-option>
            <a-select-option :value="4">任务发布扣分</a-select-option>
            <a-select-option :value="5">任务退还</a-select-option>
            <a-select-option :value="6">后台加积分</a-select-option>
            <a-select-option :value="7">填写邀请码</a-select-option>
            <a-select-option :value="8">邀请码被填写</a-select-option>
            <a-select-option :value="9">抢单扣分</a-select-option>
            <a-select-option :value="10">新用户注册奖励</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="时间区间">
          <a-range-picker
            v-model="query.timeRange"
            :show-time="{ format: 'HH:mm:ss' }"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['起始时间', '结束时间']"
            style="width: 380px"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
          <a-button style="margin-left:10px" icon="reload" @click="handleReset">重置</a-button>
          <a-button style="margin-left:10px" type="primary" icon="plus" v-permission="'app:point:add'" @click="openAddModal">加积分</a-button>
        </a-form-item>
      </a-form>
    </div>

    <a-table
      :columns="columns"
      :data-source="data"
      rowKey="id"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="user" slot-scope="text, record">
        <div>{{ record.phone || '未绑定手机号' }}</div>
        <div style="color:#999; font-size:12px;">{{ record.realName || record.displayName || record.nickname || '-' }}</div>
      </span>

      <span slot="changeType" slot-scope="text">
        <a-tag :color="getChangeTypeMeta(text).color">{{ getChangeTypeMeta(text).text }}</a-tag>
      </span>

      <span slot="pointsValue" slot-scope="text">
        <span :style="{ color: text >= 0 ? '#52c41a' : '#f5222d' }">
          {{ text >= 0 ? '+' : '' }}{{ text }}
        </span>
      </span>
    </a-table>

    <a-modal
      title="为用户增加积分"
      :visible="addModalVisible"
      :confirm-loading="submitting"
      @ok="handleAddPoints"
      @cancel="closeAddModal"
    >
      <a-form-model :model="addForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="用户ID" required>
          <a-select
            v-model="addForm.userId"
            show-search
            allow-clear
            :filter-option="false"
            :loading="userSearching"
            placeholder="输入用户ID、手机号或姓名搜索"
            style="width: 100%"
            @search="handleUserSearch"
            @focus="handleUserFocus"
          >
            <a-select-option
              v-for="user in userOptions"
              :key="user.id"
              :value="user.id"
            >
              用户ID：{{ user.id }}　手机号：{{ user.phone || '未绑定' }}　姓名：{{ user.realName || user.displayName || user.nickname || '-' }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="增加积分" required>
          <a-input-number v-model="addForm.pointsValue" :min="1" :max="100000" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea
            v-model="addForm.remark"
            :maxLength="100"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            placeholder="默认：后台手动加积分"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { addUserPoints, getAppUserOptions, getPointRecordList } from '@/api'

export default {
  data() {
    return {
      data: [],
      loading: false,
      submitting: false,
      addModalVisible: false,
      userSearching: false,
      userOptions: [],
      userSearchTimer: null,
      query: {
        userId: undefined,
        changeType: undefined,
        timeRange: []
      },
      addForm: {
        userId: undefined,
        pointsValue: 1,
        remark: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`
      },
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '用户ID', dataIndex: 'userId', width: 100 },
        { title: '手机号 / 姓名', key: 'user', scopedSlots: { customRender: 'user' } },
        { title: '当前积分', dataIndex: 'currentPoints', width: 100 },
        {
          title: '积分类型',
          dataIndex: 'changeType',
          width: 130,
          scopedSlots: { customRender: 'changeType' }
        },
        {
          title: '变动积分',
          dataIndex: 'pointsValue',
          width: 110,
          scopedSlots: { customRender: 'pointsValue' }
        },
        { title: '关联业务ID', dataIndex: 'businessId', width: 110 },
        { title: '备注', dataIndex: 'remark', ellipsis: true },
        { title: '创建时间', dataIndex: 'createdAt', width: 180 }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    validateTimeRange() {
      const range = this.query.timeRange || []
      const start = range[0]
      const end = range[1]
      if (!start || !end) {
        return { ok: true, startTime: start || undefined, endTime: end || undefined }
      }

      const startMoment = moment(start)
      const endMoment = moment(end)
      if (!startMoment.isValid() || !endMoment.isValid()) {
        return { ok: false, message: '时间格式不合法' }
      }
      if (endMoment.isBefore(startMoment)) {
        return { ok: false, message: '结束时间不能早于起始时间' }
      }
      if (endMoment.diff(startMoment, 'days', true) > 366) {
        return { ok: false, message: '时间跨度不能超过 366 天' }
      }
      return {
        ok: true,
        startTime: startMoment.toISOString(),
        endTime: endMoment.toISOString()
      }
    },
    loadData() {
      const checked = this.validateTimeRange()
      if (!checked.ok) {
        this.$message.error(checked.message)
        return
      }

      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        userId: this.query.userId || undefined,
        changeType: this.query.changeType,
        startTime: checked.startTime,
        endTime: checked.endTime
      }
      getPointRecordList(params)
        .then(res => {
          const payload = (res && res.data) || {}
          this.data = payload.records || payload.list || []
          this.pagination.total = payload.total || 0
        })
        .catch(err => {
          this.$message.error(err && err.message ? err.message : '加载失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleReset() {
      this.query = {
        userId: undefined,
        changeType: undefined,
        timeRange: []
      }
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    openAddModal() {
      this.addForm = {
        userId: this.query.userId,
        pointsValue: 1,
        remark: ''
      }
      this.addModalVisible = true
      this.loadUserOptions(this.query.userId ? String(this.query.userId) : '')
    },
    closeAddModal() {
      this.addModalVisible = false
      this.submitting = false
    },
    handleAddPoints() {
      if (!this.addForm.userId) {
        this.$message.error('请输入用户ID')
        return
      }
      if (!this.addForm.pointsValue || this.addForm.pointsValue <= 0) {
        this.$message.error('增加积分必须大于0')
        return
      }

      this.submitting = true
      addUserPoints(this.addForm)
        .then(() => {
          this.$message.success('加积分成功')
          this.closeAddModal()
          this.loadData()
        })
        .catch(err => {
          this.$message.error(err && err.message ? err.message : '操作失败')
        })
        .finally(() => {
          this.submitting = false
        })
    },
    handleUserFocus() {
      if (!this.userOptions.length) {
        this.loadUserOptions('')
      }
    },
    handleUserSearch(value) {
      if (this.userSearchTimer) {
        clearTimeout(this.userSearchTimer)
      }
      this.userSearchTimer = setTimeout(() => {
        this.loadUserOptions(value)
      }, 300)
    },
    loadUserOptions(keyword) {
      this.userSearching = true
      getAppUserOptions({ keyword: keyword || undefined })
        .then(res => {
          this.userOptions = (res && res.data) || []
        })
        .catch(err => {
          this.$message.error(err && err.message ? err.message : '用户搜索失败')
        })
        .finally(() => {
          this.userSearching = false
        })
    },
    getChangeTypeMeta(type) {
      const map = {
        1: { text: '充值赠送', color: 'green' },
        2: { text: '拉新奖励', color: 'blue' },
        3: { text: '报价扣分', color: 'red' },
        4: { text: '任务发布扣分', color: 'orange' },
        5: { text: '任务退还', color: 'purple' },
        6: { text: '后台加积分', color: 'cyan' },
        7: { text: '填写邀请码', color: 'geekblue' },
        8: { text: '邀请码被填写', color: 'gold' },
        9: { text: '抢单扣分', color: 'red' },
        10: { text: '新用户注册奖励', color: 'green' }
      }
      return map[type] || { text: '未知', color: '' }
    }
  }
}
</script>
